import { Signal } from "@lit-labs/signals";
import type { LiveEvent } from "api-contracts/rpc/get-live-events";
import type { SortState } from "ui-components/wow-base-table/types";
import type { IWritableCreatorLiveEventsState, SortEntry } from "./types";

const STATUS_ORDER: Record<string, number> = {
  live: 0,
  scheduled: 1,
  ended: 2,
  cancelled: 3,
};

export class CreatorLiveEventsState implements IWritableCreatorLiveEventsState {
  readonly events = new Signal.State<LiveEvent[]>([]);
  readonly isLoading = new Signal.State<boolean>(false);
  readonly errorMessage = new Signal.State<string>("");
  readonly activeSorts = new Signal.State<SortEntry[]>([]);

  get primarySortState(): SortState {
    const first = this.activeSorts.get()[0];
    if (!first) return { column: null, direction: "none" };
    return { column: first.column, direction: first.direction };
  }

  getSortedEvents(events: LiveEvent[]): LiveEvent[] {
    const sorts = this.activeSorts.get();
    if (sorts.length === 0) return events;

    return [...events].sort((a, b) => {
      for (const { column, direction } of sorts) {
        let cmp: number;

        if (column === "status") {
          const aOrder = STATUS_ORDER[a.status] ?? 99;
          const bOrder = STATUS_ORDER[b.status] ?? 99;
          cmp = aOrder - bOrder;
        } else {
          const aVal = (a as Record<string, unknown>)[column];
          const bVal = (b as Record<string, unknown>)[column];

          if (aVal == null && bVal == null) {
            cmp = 0;
          } else if (aVal == null) {
            cmp = 1;
          } else if (bVal == null) {
            cmp = -1;
          } else {
            cmp = String(aVal).localeCompare(String(bVal));
          }
        }

        if (cmp !== 0) return direction === "asc" ? cmp : -cmp;
      }
      return 0;
    });
  }
}
